"use client";

import React, { createContext, ReactNode, useContext, useState } from "react";

interface WhatsAppWidgetContextType {
  isWidgetVisible: boolean;
  showWidget: () => void;
  hideWidget: () => void;
}

const WhatsAppContext = createContext<WhatsAppWidgetContextType | undefined>(undefined);

export const useWhatsAppWidget = () => {
  const context = useContext(WhatsAppContext);

  if (context === undefined) {
    return {
      isWidgetVisible: true,
      showWidget: () => console.warn("WhatsApp context not available - showWidget called"),
      hideWidget: () => console.warn("WhatsApp context not available - hideWidget called"),
    };
  }

  return context;
};

interface WhatsAppProviderProps {
  children: ReactNode;
}

export const WhatsAppWidgetProvider: React.FC<WhatsAppProviderProps> = ({ children }) => {
  const [isWidgetVisible, setIsWidgetVisible] = useState(true);

  const showWidget = () => {
    setIsWidgetVisible(true);
  };

  const hideWidget = () => {
    setIsWidgetVisible(false);
  };

  const value: WhatsAppWidgetContextType = {
    isWidgetVisible,
    showWidget,
    hideWidget,
  };

  return <WhatsAppContext.Provider value={value}>{children}</WhatsAppContext.Provider>;
};
